import { Component, DestroyRef, input, OnInit, inject } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Lender, Rate} from '@app/core/stingray-api/models';
import { finalize, map } from 'rxjs/operators';
import { requireMatch } from '@app/validators/autocomplete-validator';
import {  RateAutoCompleteService } from './rate-autocomplete.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import _ from 'lodash';
import { MatListItem } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';


@Component({
    selector: 'unite-rate-autocomplete',
    templateUrl: './rate-autocomplete.component.html',
    styleUrls: ['./rate-autocomplete.component.scss'],
    imports: [MatFormField, MatLabel, MatProgressSpinner, MatSuffix, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule, MatListItem]
})
export class RateAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  control = input<FormControl>();
  required = input(false);
  focus = input(false);
  label = input<string>();
  appearance = input('outline');
  floatLabel = 'auto';
  isMatListItem = input(false);

  rates: Rate[] = [];
  ratesFiltered: Rate[];

  isLoadingRates = false;

  constructor(
    private rateAutoCompleteService: RateAutoCompleteService) { }

  ngOnInit() {
    if (this.floatLabel !== 'outline') {
      this.floatLabel = 'always';
    }

    if (this.required() === false) {
      this.control().setValidators([requireMatch]);
    } else {
      this.control().setValidators([Validators.required, requireMatch]);
    }

    this.isLoadingRates = true;
    this.rateAutoCompleteService.getRates().pipe(
      finalize(() => {
        this.isLoadingRates = false;
      })
    ).subscribe((rates: Lender[]) => {
      this.rates = _.orderBy(rates, x => x.name);
      this.ratesFiltered = rates;
    });

    this.control().valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
      map((value: string | Rate) => {
        if (this.isRate(value)) {
          return this.filterRate(value.productName);
        } else {
          return this.filterRate(value || '');
        }
      })
    ).subscribe((rates: Rate[]) => {
      this.ratesFiltered = rates;
    });
  }

  displayWithRate(rate: Rate): string {
    if (rate != null) {
      return rate.productName;
    } else {
      return '';
    }
  }

  filterRate(value: string): Rate[] {
    const filterValue = value.toLowerCase();
    return this.rates.filter((lender: Lender) => {
      return this.displayWithRate(lender).toLowerCase().includes(filterValue) ||
      String(lender.number).includes(filterValue);
    });
  }

  isRate(value: any | Rate): value is Rate {
    return value != null && (<Rate>value).number !== undefined;
  }
}
